export const rowHeight = 40;
export const tableHeight = 415;
export const defaultColumnWidth = 80;
export const chartHeight = 415;

// These widths must add to 465
export const columnWidths = {
    timestamp: 165,
    duration: 70,
    station: 70,
    show: 80,
    episode: 80,
    // market: 80,
};
